if (typeof FlourishShopAll !== 'function') {
  class FlourishShopAll extends HTMLElement {
    connectedCallback() {
      this._filters = this.querySelectorAll('[data-shop-all-filter]');
      this._items = this.querySelectorAll('[data-shop-all-item]');
      this._empty = this.querySelector('[data-shop-all-empty]');

      this._onFilterClick = this._onFilterClick.bind(this);
      this._filters.forEach((filter) => {
        filter.addEventListener('click', this._onFilterClick);
      });

      const activeFilter = this.querySelector('[data-shop-all-filter].is-active');
      if (activeFilter) {
        this._applyFilter(activeFilter.dataset.shopAllFilter || 'all');
      }
    }

    disconnectedCallback() {
      this._filters?.forEach((filter) => {
        filter.removeEventListener('click', this._onFilterClick);
      });
    }

    _onFilterClick(event) {
      const button = event.currentTarget;
      if (button.tagName === 'A') return;

      const filterValue = button.dataset.shopAllFilter || 'all';
      this._setActiveFilter(button);
      this._applyFilter(filterValue);
    }

    _setActiveFilter(activeButton) {
      this._filters.forEach((filter) => {
        if (filter.tagName === 'A') return;
        const isActive = filter === activeButton;
        filter.classList.toggle('is-active', isActive);
        filter.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    _applyFilter(filterValue) {
      let visibleCount = 0;

      this._items.forEach((item) => {
        const matches =
          filterValue === 'all' ||
          item.dataset.filterType === filterValue ||
          item.dataset.filterTags?.split(',').includes(filterValue);

        item.hidden = !matches;
        if (matches) visibleCount += 1;
      });

      if (this._empty) {
        this._empty.hidden = visibleCount > 0;
      }
    }
  }

  if (typeof customElements.get('flourish-shop-all') === 'undefined') {
    customElements.define('flourish-shop-all', FlourishShopAll);
  }
}
